import * as React from "react";
import AboutColors from "../containers/AboutColors";

export default (props) =>
  props.activeFotterMenu === 2 && <AboutColors {...props} />;
